__turbopack_context__.v({
  "root": "ForumStats-module-scss-module__nnZHsW__root",
  "time": "ForumStats-module-scss-module__nnZHsW__time",
});
